import {
    FETCH_ONBOARDING_STEPS_REQUEST,
    FETCH_ONBOARDING_STEPS_SUCCESS,
    FETCH_ONBOARDING_STEPS_FAILURE,
    UPDATE_ONBOARDING_REVIEW_SETTINGS_REQUEST,
    UPDATE_ONBOARDING_REVIEW_SETTINGS_SUCCESS,
    UPDATE_ONBOARDING_REVIEW_SETTINGS_FAILURE,
    UPDATE_ONBOARDING_STEPS_REQUEST,
    UPDATE_ONBOARDING_STEPS_SUCCESS,
    UPDATE_ONBOARDING_STEPS_FAILURE,
    SET_ONBOARDING_STEPS_COMPLETE,

} from "../actions/onBoardingAction";

const initialState = {
    loading: false,
    onBoardingSteps: {},
    error: "",
    onBoardingComplete: false,
};

const onBoardingStepsReducer = (state = initialState, action) => {
    switch (action.type) {
    case FETCH_ONBOARDING_STEPS_REQUEST:
        return { ...state, loading: true };
    case FETCH_ONBOARDING_STEPS_SUCCESS:
        return {
            ...state,
            loading: false,
            onBoardingSteps: action.payload,
            error: "",
        };
    case FETCH_ONBOARDING_STEPS_FAILURE:
        return {
            ...state,
            loading: false,
            onBoardingSteps: {},
            error: action.payload,
        };
    case UPDATE_ONBOARDING_REVIEW_SETTINGS_REQUEST:
        return { ...state, loading: true };
    case UPDATE_ONBOARDING_REVIEW_SETTINGS_SUCCESS:
        return {
            ...state,
            loading: false,
            error: "",
        };
    case UPDATE_ONBOARDING_REVIEW_SETTINGS_FAILURE:
        return {
            ...state,
            loading: false,
            error: action.payload,
        };
    case UPDATE_ONBOARDING_STEPS_REQUEST:
        return { ...state, loading: true };
    case UPDATE_ONBOARDING_STEPS_SUCCESS:
        return {
            ...state,
            loading: false,
            error: "",
        };
    case UPDATE_ONBOARDING_STEPS_FAILURE:
        return {
            ...state,
            loading: false,
            error: action.payload,
        };
    case SET_ONBOARDING_STEPS_COMPLETE:
        return {
            ...state,
            onBoardingComplete: true
        };
    default:
        return state;
    }               
};

export default onBoardingStepsReducer;
